import React from "react";
import PropTypes from "prop-types";
import Typografy from "../Typografy";

const Text = (props) => {
  const { children, text, bodyStrong, reset, as, elementType } = props;

  return (
    <Typografy
      {...props}
      textVariant={bodyStrong ? "1" : "2"}
      reset={{ marginBottom: "1rem", ...reset }}
      as={elementType || as}
    >
      {text || children}
    </Typografy>
  );
};

Text.defaultProps = {
  text: null,
  textSize: "md",
  bodyStrong: false,
  textType: "body",
  as: "p",
  reset: null,
  elementType: null,
};

Text.propTypes = {
  text: PropTypes.string,
  textSize: PropTypes.oneOf(["sm", "md", "lg"]),
  bodyStrong: PropTypes.bool,
  textType: PropTypes.oneOf([
    "body",
    "headline",
    "lead",
    "caption",
    "button",
    "link",
  ]),
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  reset: PropTypes.instanceOf(Object),
  elementType: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
};

export default Text;
